import { render, staticRenderFns } from "./loginQuick.vue?vue&type=template&id=5b9f6518&"
import script from "./loginQuick.vue?vue&type=script&lang=js&"
export * from "./loginQuick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/login/loginTemplate/loginQuick.vue"
export default component.exports